/* eslint-disable */
import React from 'react';
import Launch from '@material-ui/icons/Launch';
import Typography from '@material-ui/core/Typography';

import Faq from './Icons/FaqIcon';
import { ButtonLink, BannerBtn } from './ButtonUtils';

const FAQBannerBtn = ({ state, classes }) => {

    return (
        <BannerBtn state={state} classes={classes} icon={<Faq name="faq" />} title='FAQs' aria='faqs' buttonId='toolbar-faq-button'>
            <Typography className={classes.popoverTextHeader}>VIEW FAQs</Typography>
            <br />

            <Typography className={classes.popoverTextBody}>
                Quickly answer your questions about <Typography className={classes.popoverTextBody} display='inline' noWrap>T. Rowe Price</Typography> Retirement Advisory Service&trade;.
            </Typography>
            <br />

            <ButtonLink
                icon={<Launch className={classes.faqIcon} />}
                name="View FAQs"
                href={`${document.location.origin}/personal-investing/planning-and-research/advice/planning-service/faq.html`}
                classes={classes}
                target='_blank'
            />
        </BannerBtn>
    );
};

export default FAQBannerBtn;
